export default {
    "created": "Promotia a fost creata cu succes",
    "updated": "Promotia a fost actualizata cu succes",
    "deleted": "Promotia a fost ștearsa cu succes",
    "restored": "Promotia a fost restaurata cu succes",
}
